var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"beian"},[_vm._v(" 深圳市腾讯计算机系统有限公司 粤B2-20090059-1 ")])}
var staticRenderFns = []

export { render, staticRenderFns }